module.exports = __webpack_public_path__ + "fonts/RundigsburgPlain.db2be2b.woff";